var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"ucFirst body-1 tz-dropdown",attrs:{"aria-label":_vm.formattedAriaLabel(
        _vm.metadata[("description" + (this.upperLocale))],
        _vm.required
    ),"label":_vm.formattedLabel(
        _vm.metadata[("description" + (this.upperLocale))],
        _vm.required
    ),"value":_vm.value,"name":_vm.metadata.name,"items":_vm.dropBoxOptions,"item-text":"text","item-value":"option","outlined":_vm.outlined,"append-icon":_vm.appendIcon,"color":_vm.$vuetify.theme.primary,"background-color":_vm.$vuetify.theme.primary,"placeholder":_vm.placeholder,"validate-on-blur":"","rules":[
        !_vm.required || _vm.requiredField()
    ],"data-meta-id":_vm.metadata.id,"id":_vm.metadata.name},on:{"input":_vm.emitValue}})}
var staticRenderFns = []

export { render, staticRenderFns }